import { MutableRefObject } from 'react';

const useAuthTokens = ({
  token,
  idToken,
  getAuthTokens,
}: {
  token: MutableRefObject<string>;
  idToken: MutableRefObject<string>;
  getAuthTokens: (options?: any) => Promise<any>;
}) => {
  const fetchAndSetTokens = async (options?: any) => {
    const sessionTokens = await getAuthTokens(options);

    const accessToken = sessionTokens?.accessToken.toString();
    const idTokenTemp = sessionTokens?.idToken?.toString() || '';

    if (!accessToken) {
      token.current = '';
      throw new Error('No access token');
    }

    if (!idTokenTemp) {
      idToken.current = '';
      throw new Error('No id token');
    }

    token.current = accessToken;
    idToken.current = idTokenTemp;

    return sessionTokens;
  };

  const calculateDurationBeforeRefreshingToken = (
    expFromToken: number,
  ): number => {
    const computedDateFromExp = new Date(expFromToken * 1000);
    const nowDate = new Date();
    return computedDateFromExp.getTime() - nowDate.getTime();
  };

  const refreshToken = (delay: number) => {
    const expFromToken = calculateDurationBeforeRefreshingToken(delay);

    setTimeout(async () => {
      const sessionTokens = await fetchAndSetTokens({ forceRefresh: true });

      const exp = sessionTokens?.accessToken?.payload?.exp;
      if (exp) {
        refreshToken(exp);
      }
    }, expFromToken - 30000);
  };

  return {
    refreshAuthToken: refreshToken,
    fetchAndSetAuthTokens: fetchAndSetTokens,
  };
};

export default useAuthTokens;
